import React, { useContext } from 'react';
import Layout from '../engine/layout';
import { Typography, Carousel } from 'antd';
import DailyBonus from '../engine/widgets/DailyBonus';
import TablesCounter from '../engine/widgets/Tables';
import Leader from '../engine/widgets/Leader';
import Gametable from '../engine/widgets/GameTable';
import CreateRoom from '../engine/widgets/CreateRoom';
import { AppContext } from '../App';

import timer from '../resources/timer.svg';
import lock from '../resources/lock.svg';

const LeagueWrapper = (props) => {
    const app = useContext(AppContext);

    return <League app={app} {...props} />;
}

class League extends Layout {
    constructor(props) {
        super(props);

        this.app = props.app;
        this.league = false;
        this.timeout = false;

        this.roomData = {
            bet: 1000,
            type: `P`,
            minGames: 1,
            isFast: true,
            isLocked: false,
            is4Player: false,
        };

        this.state = {
            rooms: [],
            hasLobby: false,
            activeRooms: 0,
            openRooms: 0,
            pageSize: 3,
            page: 1,
        };
    }

    connect = () => {
        const { websock } = this.app.state;

        if (websock.ready && !this.league) {
            this.league = this.app.fn.websock.subscribe(`league`);
            if (!this.league) return;

            this.league.on(`lobby.list`, (e) => {
                this.setState({ 
                    rooms: [ ...e.rooms ],
                    activeRooms: e.active_lobbies,
                    hasLobby: this.includesCurrentUser([ ...e.rooms ])
                });
            });
            this.league.on(`lobby.invite`, (e) => {
                // this.props.client.game = { id: e.game.id };
                this.app.fn.websock.unsubscribe(`league`);
                this.app.fn.client.navigate( `/play/${e.id}`, `Zolmaņiem | Spēlēt` );
            });
        } else if (!websock.ready) {
            this.league = false;
        }
    };

    componentDidMount() {
        this.app = this.props.app;
        
        this.connect();
    }

    componentDidUpdate() {
        this.app = this.props.app;

        this.connect();
    }

    includesCurrentUser = (lobbies) => {
        const { user } = this.app.state;

        if (user.id) {
            for (const lobby of lobbies) {
                for (const player of lobby.players) {
                    if (player.id === user.id) {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    content (layout = `desktop`) {
        if (layout === `desktop`) {
            return this.contentWide();
        }

        return this.contentMobile();
    }

    create = async () => {
        const { ready } = this.app.state.websock;

        if (ready && this.league && !this.state.hasLobby) {
            this.league.whisper(`lobby.create`, { ...this.roomData });
        }
    };

    joinOrLeave = async (id) => {
        const { ready } = this.app.state.websock;

        if (ready && this.league) {
            if (!this.state.hasLobby) {
                this.league.whisper(`lobby.join`, { id });
            } else {            
                this.league.whisper(`lobby.leave`, { id });
            }
        }
    };

    head() {
        const { user, client } = this.app.state;

        return (
            <div style={{
                height: `max(22vh, 280px)`,
            }}>
                <Typography.Title
                    level={2}
                    style={{
                        color: `#F3DD8E`,
                        fontSize: 36,
                        margin: `4vh 0 30px 0`,
                        textAlign: `center`
                    }}
                >
                    Zolmaņu līga
                </Typography.Title>
                <div style={{
                    padding: `0 10px`,
                    display: `flex`,
                    width: `100%`,
                    justifyContent: `center`
                }}>
                    <div
                        style={{
                            background: `#E2C354`,
                            minWidth: 100,
                            maxWidth: 160,
                            width: `33vw`,
                            minHeight: 180,
                            maxHeight: 230,
                            boxShadow: `0px 4px 4px rgba(0, 0, 0, 0.25)`,
                            borderRadius: 6,
                            padding: `20px 5px 5px 5px`,
                            zIndex: 9,
                            margin: `0 ${this.props.size > 575 ? `10` : `5`}px`,
                        }}
                    >
                        <DailyBonus day={user.dailyStreak} size={client.window.size.width} />
                    </div>
                    <div
                        style={{
                            background: `#E2C354`,
                            minWidth: 100,
                            maxWidth: 160,
                            width: `33vw`,
                            minHeight: 180,
                            maxHeight: 230,
                            boxShadow: `0px 4px 4px rgba(0, 0, 0, 0.25)`,
                            borderRadius: 6,
                            padding: `20px 5px 5px 5px`,
                            zIndex: 9,
                            margin: `0 ${client.window.size.width > 575 ? `10` : `5`}px`,
                        }}
                    >
                        <TablesCounter count={this.state.activeRooms} size={client.window.size.width} />
                    </div>
                    <div
                        style={{
                            background: `#E2C354`,
                            minWidth: 100,
                            maxWidth: 160,
                            width: `33vw`,
                            minHeight: 180,
                            maxHeight: 230,
                            boxShadow: `0px 4px 4px rgba(0, 0, 0, 0.25)`,
                            borderRadius: 6,
                            padding: `20px 5px 5px 5px`,
                            zIndex: 9,
                            margin: `0 ${client.window.size.width > 575 ? `10` : `5`}px`,
                        }}
                    >
                        <Carousel fade infinite speed={8000} effec="fade" dots={false} autoplay>
                            {
                                user.topPlayers.map(p => (
                                    <Leader name={p.name} count={p.wins} size={client.window.size.width} />
                                ))
                            }
                        </Carousel>
                    </div>
                </div>
            </div>
        );
    }

    contentMobile() {
        // const { user } = this.app.state;

        return (
            <>
                {this.head()}
                <div className={`main-content-box-mobile`} style={{ margin: `-15px auto 0 auto` }}> 
                    <div style={{ height: 50, width: `100%` }} />
                    <div style={{ display: `table`, width: `100%` }}>
                        <Gametable
                            app={this.app}
                            style={{ display: `block`, maxWidth: 800, width: `100%`, margin: `auto` }}
                            tableStyle={{ maxWidth: 800, width: `100%`, margin: `auto` }}
                            data={this.state.rooms}
                            size={this.state.openRooms}
                            hasLobby={this.state.hasLobby}
                            onMore={() => this.setState(old => ({ page: old.page + 1 }))}
                            onJoin={(id) => this.joinOrLeave(id)}
                        />
                        <CreateRoom callback={(data) => this.roomData = { ...data }} />
                        <div
                            className={`button${this.state.hasLobby ? ` inactive` : ``}`}
                            style={{
                                display: `inline-block`,
                                marginTop: 35,
                                marginLeft: 10,
                            }}
                            onClick={() => this.create()}
                        >
                            Izveidot galdu
                        </div>
                        <Typography.Text style={{
                            color: `#606060`,
                            fontSize: 16,
                            display: `block`,
                            marginBottom: 20,
                            marginTop: 20,
                            marginLeft: 10,
                            maxWidth: 800,
                            width: `100%`,
                        }}>
                            <div>P - ar pulēm</div>
                            <div>G - ar galdiņu</div>
                            <div>PM - ar pulēm un mazo zoli</div>
                            <div>GM - ar galdiņu un mazo zoli</div>
                            <div>4 - zole četratā</div>
                            <div>cipars - minimālais partiju skaits</div>
                            <div><img src={timer} alt="timer" style={{ width: 15 }} /> - veiklā,</div>
                            <div><img src={lock} alt="lock" style={{ width: 15 }} /> - draugu galds</div>
                        </Typography.Text>
                    </div>
                </div>
            </>
        );
    }

    contentWide() {
        const { user, client } = this.app.state;

        return (
            <>
                <table
                    style={{
                        width: `100%`,
                    }}
                >
                    <tr>
                        <td
                            rowSpan={2}
                            style={{
                                verticalAlign: `top`,
                                width: 200,
                            }}
                        >
                            <div
                                style={{
                                    background: `#E2C354`,
                                    width: 160,
                                    minHeight: 400,
                                    boxShadow: `0px 4px 4px rgba(0, 0, 0, 0.25)`,
                                    borderRadius: 6,
                                    paddingTop: 35,
                                }}
                            >
                                <DailyBonus day={user.dailyStreak} size={client.window.size.width} />
                                <TablesCounter count={this.state.activeRooms} size={client.window.size.width} />
                                <Carousel fade infinite speed={8000} effec="fade" dots={false} autoplay>
                                    {
                                        user.topPlayers.map(p => (
                                            <Leader name={p.name} count={p.wins} size={client.window.size.width} />
                                        ))
                                    }
                                </Carousel>
                                <br />
                            </div>
                        </td>
                        <td
                            style={{
                                verticalAlign: `top`,
                            }}
                        >
                            <Typography.Title level={2}>Zolmaņu līga</Typography.Title>
                            <Gametable
                                app={this.app}
                                data={this.state.rooms}
                                size={this.state.openRooms}
                                hasLobby={this.state.hasLobby}
                                onMore={() => this.setState(old => ({ page: old.page + 1 }))}
                                onJoin={(id) => this.joinOrLeave(id)}
                            />
                            <CreateRoom callback={(data) => this.roomData = { ...data }} />
                            <div
                                className={`button${this.state.hasLobby ? ` inactive` : ``}`}
                                style={{
                                    display: `inline-block`,
                                    marginTop: 35,
                                    marginLeft: 10,
                                }}
                                onClick={() => this.create()}
                            >
                                Izveidot galdu
                            </div>
                            <Typography.Text style={{
                                color: `#606060`,
                                fontSize: 16,
                                display: `block`,
                                marginTop: 20,
                                marginLeft: 10,
                                marginBottom: 20,
                            }}>
                                
                            <div>P - ar pulēm</div>
                            <div>G - ar galdiņu</div>
                            <div>PM - ar pulēm un mazo zoli</div>
                            <div>GM - ar galdiņu un mazo zoli</div>
                            <div>4 - zole četratā</div>
                            <div><em>cipars</em> - minimālais partiju skaits</div>
                            <div><img src={timer} alt="timer" style={{ width: 15 }} /> - veiklā</div>
                            <div><img src={lock} alt="lock" style={{ width: 15 }} /> - draugu galds</div>
                            </Typography.Text>
                        </td>
                    </tr>
                </table>
            </>
        );
    }
}

export default LeagueWrapper;
